module.exports = "/_next/static/images/PowerInfrastructureSolutions-bfb7386d82760244554ce07dbe066345.webp";